import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ApplicantScoreDisplay = ({ finalScore, scoreBreakdown, tooltipId }) => {
    const breakdown = scoreBreakdown || [];
    const isAdjusted = breakdown.length > 1;

    return (
        <span>
            {finalScore != null ? finalScore : ""}
            {isAdjusted && (
                <>
                    <FontAwesomeIcon
                        icon="info-circle"
                        className="text-info ml-2"
                        data-tip
                        data-for={tooltipId}
                    />
                    <ReactTooltip id={tooltipId} effect="float">
                        <div className="text-left">
                            {breakdown.map((item, idx) => (
                                <div key={idx}>{item.label}: {item.score}</div>
                            ))}
                        </div>
                    </ReactTooltip>
                </>
            )}
        </span>
    );
};

ApplicantScoreDisplay.propTypes = {
    finalScore: PropTypes.number,
    scoreBreakdown: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        score: PropTypes.number
    })),
    tooltipId: PropTypes.string.isRequired
};

export default ApplicantScoreDisplay;
